import { CUSTOMFIELD_TYPE_IDS } from './../../../modules/shared/constants/typeId';
import { SavedSearchNS } from "../models/saved-search.models";
import { MultiSelectFieldsNS } from '../models/saved-search-multiselect-fields.static';

export function prepareSavedSearchAddEditFilter(rule: SavedSearchNS.SavedSearchRuleRequest): SavedSearchNS.IField {
    let filter: SavedSearchNS.IField = {
        id: 0,
        labelname: rule.labelName,
        parentLabelName: rule?.parentLabelName||"",
        name: rule.criteria,
        code: rule.criteria,
        isrequired: true,
        ischecked: true,
        isShowInSetting: true,
        isDuplicate: false,
        isGlobalSearch: true,
        width: null,
        movable: true,
        showForDrag: true,
        templateId: rule.templateId,
        sectionId: 0,
        custom: rule.isCustom,
        formControlId: 0,
        formControl: rule.dataType,
        pickListValues: 0,
        field: rule.criteria,
        mapObject: rule.objectName,
        isColumnSetting: true,
        value: null,
        displayOrder: rule.sequenceOrder,
        fieldTypes: null,
        fieldDataType: rule.dataType,
        valueDataType: null,
        operators: null,
        operatorsDD: [],
    }
    setSavedSearchValueDateType(filter);
    return filter;
}

export function setSavedSearchValueDateType(field: SavedSearchNS.IField) {
    if (field.custom == true) {
        if(field?.formControlId == CUSTOMFIELD_TYPE_IDS.USERLOOKUP){
            field.valueDataType = 'User';
        }
        else if (
            field.fieldDataType == 'Enum' ||
            field?.formControlId == CUSTOMFIELD_TYPE_IDS.MULTISELECT ||
            field?.formControlId == CUSTOMFIELD_TYPE_IDS.DROPDOWN ||
            field?.formControlId == CUSTOMFIELD_TYPE_IDS.CHECKBOX ||
            field?.formControlId == CUSTOMFIELD_TYPE_IDS.RADIO_BUTTON ||
            field?.formControlId == CUSTOMFIELD_TYPE_IDS.RATING) {
            field.valueDataType = 'MultiSelect';
        } else if (field.fieldDataType == 'Number') {
            field.valueDataType = 'Number';
        } else if (field.fieldDataType == 'Decimal') {
            field.valueDataType = 'Decimal';
        } else {
            field.valueDataType = 'String';
        }
    }
    else {
        if (field.fieldDataType == 'Number' || field.fieldDataType == 'Money') {
            field.valueDataType = 'Number';
        }else if (field.fieldDataType == 'Decimal') {
            field.valueDataType = 'Decimal';
        }
        else if (
            MultiSelectFieldsNS.AutoCompleteDropdownFieldsArray.includes(field.field?.toLowerCase()) ||
            MultiSelectFieldsNS.AutoCompleteProductFieldsArray.includes(field.field?.toLowerCase())
        ) {
            field.valueDataType = 'AutoCompleteDropdown';
        }
        else if (field.fieldDataType == 'String') {
            field.valueDataType = 'String';
        }
        //User Type
        else if (MultiSelectFieldsNS.UserFieldsArray.includes(field.field?.toLowerCase())
        ) {
            field.valueDataType = 'User';
        }
        else if (['opportunity_country','trans_location_country','manufacturercountryid','trans_item_product_manufacturercountry','country','trans_billing_country','trans_shipping_country','trans_address_country'].includes(field.field?.toLowerCase())) {
            field.valueDataType = 'Country';
        }
        else if (field.field?.toLowerCase() == 'foundedyear') {
            field.valueDataType = 'Year';
        }
        else if (MultiSelectFieldsNS.TreeSelectFieldsArray.includes(field.field?.toLowerCase())) {
            field.valueDataType = 'TreeSelect';
        }
        else if (field.field?.toLowerCase() == 'radius') {
            field.valueDataType = 'Distance';
        }
        else if (MultiSelectFieldsNS.MultiSelectFieldsArray.includes(field.field?.toLowerCase())
        ) {
            field.valueDataType = 'MultiSelect';
        }
        else if (MultiSelectFieldsNS.DropdownFieldsArray.includes(field.field?.toLowerCase())
        ) {
            field.valueDataType = 'DropdownList';
        }else {
            field.valueDataType = 'String';
        }
    }
}
